import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SettingsProvider, LeadProvider } from "./lib/store";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import MobileStickyBar from "./components/MobileStickyBar";
import LeadModal from "./components/LeadModal";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import DestinationDetail from "./pages/DestinationDetail";
import LandArrangement from "./pages/LandArrangement";
import PackageDetail from "./pages/PackageDetail";
import CustomTrip from "./pages/CustomTrip";
import PrivateTrip from "./pages/PrivateTrip";
import CorporateGroup from "./pages/CorporateGroup";
import Services from "./pages/Services";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
          <p className="font-heading text-2xl font-bold text-tosca-700">Ada kendala menampilkan halaman</p>
          <p className="text-slate-500">Silakan muat ulang halaman ini.</p>
          <a className="btn btn-primary" href="/">Kembali ke Home</a>
        </div>
      );
    }
    return this.props.children;
  }
}

function LenisBoot() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 py-32 text-center">
      <p className="eyebrow">404</p>
      <h1 className="font-heading text-3xl font-bold text-charcoal">Halaman tidak ditemukan</h1>
      <Link className="btn btn-primary" to="/" data-testid="notfound-home-button">Kembali ke Home</Link>
    </div>
  );
}

function AppShell() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin/*" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/destinations/:slug" element={<DestinationDetail />} />
          <Route path="/land-arrangement" element={<LandArrangement />} />
          <Route path="/land-arrangement/:slug" element={<PackageDetail />} />
          <Route path="/custom-trip" element={<CustomTrip />} />
          <Route path="/private-trip" element={<PrivateTrip />} />
          <Route path="/corporate-group" element={<CorporateGroup />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <div className="h-[72px] md:hidden" />
      <FloatingWhatsApp />
      <MobileStickyBar />
      <LeadModal />
    </>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <SettingsProvider>
        <BrowserRouter>
          <LenisBoot />
          <LeadProvider>
            <AppShell />
          </LeadProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SettingsProvider>
    </ErrorBoundary>
  );
}
